import { Stage } from "transition-hook"

export const DEFAULT_ANIMATION = {
  initial: { opacity: 0, scale: 0.8 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0 },
}

export const OPACITY_ANIMATION = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}

export const MOVE_DOWN = {
  initial: { opacity: 0, x: "-50%", y: -1000 },
  animate: { opacity: 1, x: "-50%", y: 0 },
  exit: { opacity: 0, y: -1000 },
  transition: {
    duration: 0.6,
    type: "spring",
  },
}

export const MOVE_UP = {
  initial: { opacity: 0, x: "50%", y: 200 },
  animate: { opacity: 1, x: "50%", y: 0 },
  exit: { opacity: 0, y: 200 },
  transition: {
    duration: 0.3,
    type: "spring",
  },
}

export const animateJSX = (
  transition: {
    stage: Stage
    shouldMount: boolean
  },
  animation: string = "presence"
): string =>
  `jsx__${animation} jsx__${animation}__${
    ["from", "leave"].includes(transition.stage) ? "loading" : "loaded"
  }`
